import { AuxGridConstants } from "@blk/aladdin-react-components-es";
import { InsGridAggs } from "./grid-agg-funcs";
import { GroupingColumnCellRenderer } from "./renderers";
export const getStatusBar = (serverSideOptions, shouldDisplayTotalRows, hasPagination = false) => {
    if (serverSideOptions) {
        return undefined;
    }
    if (shouldDisplayTotalRows && hasPagination) {
        return {
            statusPanels: [
                { align: "left", statusPanel: "agTotalAndFilteredRowCountComponent" },
                { align: "center", statusPanel: "agTotalRowCountComponent" }
            ]
        };
    }
    if (shouldDisplayTotalRows) {
        return { statusPanels: [{ align: "left", statusPanel: "agTotalAndFilteredRowCountComponent" }] };
    }
    return undefined;
};
export const forcePutLabelTotalInFirstColumnOfFooter = (colDefs) => {
    if (!colDefs || colDefs.length <= 0) {
        return;
    }
    if (!colDefs[0].aggFunc || colDefs[0].aggFunc !== InsGridAggs.putStringValueTotalsInColumnFooter) {
        colDefs[0].aggFunc = InsGridAggs.putStringValueTotalsInColumnFooter;
    }
    if (colDefs[1]?.aggFunc === InsGridAggs.putStringValueTotalsInColumnFooter) {
        colDefs[1].aggFunc = null;
    }
    if (colDefs[0].children) {
        forcePutLabelTotalInFirstColumnOfFooter(colDefs[0].children);
    }
};
export const applyDisplayTotals = (shouldDisplayTotalsOnGrid, shouldDisplayRowNumber, props) => {
    if (shouldDisplayTotalsOnGrid) {
        forcePutLabelTotalInFirstColumnOfFooter(props.columnDefs);
    }
    if (shouldDisplayRowNumber && !props.columnDefs?.some((prop) => prop.field === "RowNumber")) {
        const rowNumberField = {
            field: "RowNumber",
            headerName: "",
            valueGetter: (params) => params?.node?.rowIndex + 1,
            width: 50
        };
        props.columnDefs?.unshift(rowNumberField);
    }
};
export const getAutoGroupColumnDef = (autoGroupOptions, pivotMode, columnDefs) => ({
    cellRendererParams: {
        innerRenderer: GroupingColumnCellRenderer,
        suppressCount: autoGroupOptions.suppressCount === true || pivotMode
    },
    ...autoGroupOptions.field ? { field: autoGroupOptions.field } : {},
    ...autoGroupOptions.headerName ? { headerName: autoGroupOptions.headerName } : {},
    ...autoGroupOptions.minWidth ? { minWidth: autoGroupOptions.minWidth } : {},
    ...autoGroupOptions.sortable === false ? { sortable: false } : {},
    ...autoGroupOptions.suppressHeaderMenuButton === true ? { suppressHeaderMenuButton: autoGroupOptions.suppressHeaderMenuButton } : {},
    ...autoGroupOptions.pinned ? { pinned: autoGroupOptions.pinned } : {},
    sort: autoGroupOptions.sort === true || pivotMode
        ? columnDefs?.find((c) => c.rowGroup === true)?.sort
        : null
});
export const applyFilterModelToGrid = (grid, filterModel) => {
    const currentFilterModel = grid.current?.api.getFilterModel();
    if (filterModel && currentFilterModel && Object.keys(currentFilterModel).length === 0) {
        grid.current?.api.setFilterModel(filterModel);
    }
};
export const collapseAllGroups = (grid, groupDefaultCollapsed) => {
    if (groupDefaultCollapsed) {
        grid.current?.api.collapseAll();
    }
};
export const selectNodesByKeyField = (grid, keyField, selectedKeys) => {
    if (!keyField || !selectedKeys) {
        return;
    }
    grid.current?.api.forEachNode((node) => {
        if (selectedKeys.includes(node.data[keyField])) {
            node.setSelected(true);
        }
    });
};
export const autoSizeGridColumns = (grid, applyColumnsAutosize, autoGroupColumnAutoSize) => {
    if (applyColumnsAutosize) {
        setTimeout(() => {
            grid.current?.api.autoSizeAllColumns();
        }, 0);
    }
    else if (autoGroupColumnAutoSize) {
        grid.current?.api?.autoSizeColumns([AuxGridConstants.AG_GRID_AUTO_COLUMN_ID]);
    }
};
export const adjustHorizontalScroll = (grid) => {
    const headerContainerAll = document.querySelectorAll(".ag-header-container");
    const headerContainer = headerContainerAll.length > 1 ? headerContainerAll[1] : headerContainerAll[0];
    const headerViewportAll = document.querySelectorAll(".ag-header-viewport ");
    const headerViewport = headerViewportAll.length > 1 ? headerViewportAll[1] : headerViewportAll[0];
    const shouldShowScroll = (headerContainer?.clientWidth ?? 1) >= (headerViewport?.clientWidth ?? 0);
    grid.current?.api.setGridOption("alwaysShowHorizontalScroll", shouldShowScroll);
};
export const createGridAdjustmentCallback = (grid, restoreColumnState, options) => () => {
    if (grid.current?.api) {
        applyFilterModelToGrid(grid, options.filterModelToApply);
        restoreColumnState();
        collapseAllGroups(grid, options.groupDefaultCollapsed);
        selectNodesByKeyField(grid, options.keyField, options.selectedKeys);
        autoSizeGridColumns(grid, options.applyColumnsAutosize, options.autoGroupColumnAutoSize);
    }
};
